import { IconType } from 'react-icons/lib';

import { Box, Flex, Icon, Text } from '@brand/components';

import ComponentIsVisible from 'components/utils/IsVisible';

interface ILayoutSubheaderProps {
  backgroundColor?: string;
  iconName?: IconType;
  subtitle?: string;
  title?: string;
  withIcon?: boolean;
}

const LayoutSubheader = ({
  backgroundColor = 'secondary',
  iconName,
  subtitle,
  title,
  withIcon,
}: ILayoutSubheaderProps): JSX.Element => {
  return (
    <Box
      backgroundColor={backgroundColor}
      borderRadius={[0, 6]}
      mb={4}
      width="100%"
    >
      <Flex alignItems="center" maxH={8} maxW="100%" mx="auto">
        <ComponentIsVisible when={!!withIcon && !!iconName}>
          <Box
            alignItems="center"
            backgroundColor="white"
            borderColor={backgroundColor}
            borderRadius={24}
            borderWidth={2}
            boxShadow="md"
            color={backgroundColor}
            display="flex"
            h={12}
            justifyContent="center"
            mx={[2, 4]}
            w={12}
          >
            <Icon as={iconName as IconType} h={6} width={6} />
          </Box>
        </ComponentIsVisible>
        <Text color="white" flex={1} fontWeight="medium" pr={[4, 8]}>
          {title}
        </Text>
        <Text color="white" fontWeight="medium" pr={[4, 8]}>
          {subtitle}
        </Text>
      </Flex>
    </Box>
  );
};

export default LayoutSubheader;
